// ---------------------------------------------------------------------------
// ---------------------------------------------------------------------------
// ----------------- Nur für Beschwerdemanagement RD ECK ---------------------
// ---------------------------------------------------------------------------
// ---------------------------------------------------------------------------

import { SET_NEW_ISSUE_DRAWER_STATE, SET_NEW_ISSUE_PROP_VALUE, RESET_NEW_ISSUE_FORM, SERVER_SEND_NEW_ISSUE } from 'constants/ActionTypes';

export const setNewIssueDrawerState = payload => {
	return { type: SET_NEW_ISSUE_DRAWER_STATE, payload };
};

export const setNewIssuePropValue = payload => {
	return { type: SET_NEW_ISSUE_PROP_VALUE, payload };
};

export const resetNewIssue = reportsDefaultInvisible => {
	return { type: RESET_NEW_ISSUE_FORM, payload: { reportsDefaultInvisible } };
};

export const sendNewIssue = reportData => {
	return { type: SERVER_SEND_NEW_ISSUE, payload: { reportData } };
};



// WEBPACK FOOTER //
// ./actions/NewIssue.js